export default __webpack_public_path__ + "static/media/mz.49226d9a.svg";